export default __webpack_public_path__ + "static/media/myjourney-bluetree-fruitnut.b18ee557.svg";